/**
 * Positions of scroll that can be done to bring and element in view.
 */
export enum ScrollInViewType {
  TOP = 'top',
  BOTTOM = 'bottom',
  ANY = 'any',
}

export enum ScrollInViewBehaviourType {
  AUTO = 'auto',
  SMOOTH = 'smooth',
}

const scrollBehaviour = (window as any).CY_DISABLE_SMOOTH_SCROLL
  ? ScrollInViewBehaviourType.AUTO
  : ScrollInViewBehaviourType.SMOOTH;

const scrollInView = {
  isInView(element: HTMLElement, type: ScrollInViewType = ScrollInViewType.TOP, customTop?: number): boolean {
    const position = element?.getBoundingClientRect();
    const windowHeight = window.innerHeight || 0;
    const yTop = position.top;
    const yBottom = position.top + position.height;

    if (type === ScrollInViewType.ANY) {
      return (
        (yTop < (customTop || 0) && yBottom > windowHeight) ||
        (yTop > (customTop || 0) && yTop < windowHeight) ||
        (yBottom > 0 && yBottom < windowHeight)
      );
    } else if (type === ScrollInViewType.TOP) {
      return yTop > (customTop || 0) && yTop < windowHeight;
    } else if (type === ScrollInViewType.BOTTOM) {
      return yBottom > 0 && yBottom < windowHeight;
    }
  },

  scrollInView(
    element: HTMLElement,
    type: ScrollInViewType = ScrollInViewType.TOP,
    scrollInViewType?: ScrollInViewBehaviourType,
  ): void {
    const scrollInViewBehaviour: ScrollInViewBehaviourType = scrollInViewType ?? scrollBehaviour;
    if (element.scrollIntoView) {
      if (type === ScrollInViewType.ANY) {
        element.scrollIntoView({ block: 'nearest', behavior: scrollInViewBehaviour });
      } else if (type === ScrollInViewType.TOP) {
        element.scrollIntoView({ block: 'start', behavior: scrollInViewBehaviour });
      } else if (type === ScrollInViewType.BOTTOM) {
        element.scrollIntoView({ block: 'end', behavior: scrollInViewBehaviour });
      }
    } else {
      const position = element.getBoundingClientRect();
      const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      const yTop = position.top;
      const yBottom = position.top + position.height;
      const padding = 10;

      if (type === ScrollInViewType.ANY) {
        document.documentElement.scrollTop -= -yTop + padding;
      } else if (type === ScrollInViewType.TOP) {
        document.documentElement.scrollTop -= -yTop + padding;
      } else if (type === ScrollInViewType.BOTTOM) {
        document.documentElement.scrollTop += yBottom + padding - windowHeight;
      }
    }
  },
};

export default scrollInView;
